import { TipoCondPagto } from './../../model/financeiro/tipoCondPagto';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class TipoCondPagtoService extends GenericService<TipoCondPagto>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("tipocondpagto")
  }
}
